import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgCircleSolidIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    stroke: "currentColor",
    strokeWidth: 1.2,
    fill: "currentColor"
  }));
}

export { SvgCircleSolidIcon as default };
